export default __webpack_public_path__ + "static/media/placeholder12.e9872a15.png";